function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 2v2h-2v13h-2V4h-2v13H9V9a3.777 3.777 0 01-4-3.5A3.78 3.78 0 019 2zm5 17H3.7l1.63-1.62-.71-.71-2.81 2.81 2.81 2.81.71-.71L3.74 20H22z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});

var SvgRtl = function SvgRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 20"
  }, props), _ref, _ref2);
};

export default SvgRtl;